import React from 'react'
import { Button, Container, Image, Nav, Navbar } from 'react-bootstrap'
import { BsMoon, BsSun } from 'react-icons/bs'
import { useTheme } from '@config/themeContext'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '@store/store'
import { logout } from '@services/auth.service'
import { Link } from 'react-router-dom'

const Header = () => {
  const { theme, toggleTheme } = useTheme()
  const dispatch = useDispatch<AppDispatch>()

  const handleLogout = () => {
    dispatch(logout())
  }

  return (
    <Navbar bg={'dark'} variant={'dark'} expand="md">
      <Container>
        <Navbar.Brand href="/">
          <Image src={'/dark_mode_small.png'} width="150px" alt="Logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Link to="/" className="nav-link">
              Dashboard
            </Link>
            <Link to="/editor" className="nav-link">
              Editor
            </Link>
            <Link to="/help" className="nav-link">
              Help
            </Link>
          </Nav>
          <Nav className="align-items-center flex-row ">
            <Button
              onClick={toggleTheme}
              variant={'outline-light'}
              className="me-1"
            >
              {theme == 'dark' ? <BsSun /> : <BsMoon />}
            </Button>
            <Button onClick={handleLogout} variant="danger">
              Odhlásit
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default Header
